<ng-container
  *ngIf="
    devicesStore.isLegacyDeviceWithoutBoilerSerial$ | async;
    else isNotLegacyOrHasBoilerSerialDevice
  "
>
  <app-banner type="info">{{
    '+REMOTE_SERVICE.LEGACY_DEVICE_MISSING_SERIAL' | translate
  }}</app-banner>
</ng-container>

<ng-template #isNotLegacyOrHasBoilerSerialDevice>
  <div class="wrapper">
    <span class="datepicker">
      <span class="datepicker-text">{{ '+REMOTE_SERVICE.DATEPICKER_TOOLTIP' | translate }}:</span>
      <mat-form-field appearance="fill" (click)="picker.open()">
        <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>

        <mat-date-range-input
          matDateRangePicker
          [formGroup]="dateRange"
          [rangePicker]="picker"
          [min]="minRangepickerDate"
          [max]="maxRangepickerDate"
          gtm="onSelect"
          gtmAction="Remote Inspection Range"
          gtmCategory="RemoteInspection"
          data-at-rangepicker
        >
          <input
            readonly
            matStartDate
            formControlName="start"
            placeholder="{{ '+GENERAL.RANGEPICKER_START_DATE' | translate }}"
            fieldTextContentTooltip
          />
          <input
            readonly
            matEndDate
            formControlName="end"
            placeholder="{{ '+GENERAL.RANGEPICKER_END_DATE' | translate }}"
            (dateChange)="setDayRange()"
            fieldTextContentTooltip
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <button
          data-at-rangepicker-clear-btn
          class="rangepicker-clear-btn"
          *ngIf="customDateRange"
          mat-icon-button
          gtm="onClearSearch"
          gtmAction="Remote Service date"
          gtmCategory="remoteService"
          (click)="resetRange($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </span>

    <ng-container [ngSwitch]="remoteServiceStore.remoteServiceFeaturesLoadingStatus$ | async">
      <ng-container *ngSwitchCase="RemoteServiceFeaturesLoadingStatus.DataPresent">
        <ng-container
          *ngIf="featuresChartSeries?.length > 0; then featuresCharts; else noFeatures"
        ></ng-container>

        <ng-template #featuresCharts>
          <div
            class="grid"
            *ngIf="remoteServiceStore.featuresChartsDetails$ | async as featuresChartsDetails"
          >
            <app-feature-list-container
              *ngFor="let chartSeries of featuresChartSeries; trackBy: trackBy"
            >
              <app-remote-service-chart
                [chartExtremes]="featuresChartsDetails.chartExtremes"
                [chartTimestamps]="featuresChartsDetails.chartTimestamps"
                [chartFeatures]="chartSeries.series"
                [titleKey]="chartSeries.seriesNameKey"
                [chartType]="'line'"
                [synchroniseExtremes]="true"
              ></app-remote-service-chart>
            </app-feature-list-container>
          </div>
        </ng-template>

        <ng-template #noFeatures>
          <app-banner type="info">{{
            '+REMOTE_SERVICE.ERROR_DATA_NOT_FOUND' | translate
          }}</app-banner>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="RemoteServiceFeaturesLoadingStatus.NoData">
        <app-banner type="info">{{
          '+REMOTE_SERVICE.ERROR_DATA_NOT_FOUND' | translate
        }}</app-banner>
      </ng-container>

      <ng-container *ngSwitchCase="RemoteServiceFeaturesLoadingStatus.DataWithNotSupportedFeatures">
        <app-banner type="info">{{
          '+REMOTE_SERVICE.NO_DATA_AVAILABLE_FOR_PERIOD' | translate
        }}</app-banner>
      </ng-container>

      <ng-container *ngSwitchCase="RemoteServiceFeaturesLoadingStatus.DataLoading">
        <vi-loader
          body
          [isLoading]="true"
          message="{{ '+REMOTE_SERVICE.LOADING_DATA' | translate }}"
        ></vi-loader>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
